import { computed, Injectable, signal } from "@angular/core";
import { ToastItem } from "../Dto/ToastModel";

@Injectable({ providedIn: "root" })
export class ToastState {
  private readonly state = signal<ToastItem[]>([]);

  public readonly data = computed(() => this.state());

  setToasts(toasts: ToastItem[]): void {
    this.state.set(toasts);
  }

  addToast(toast: ToastItem): void {
    this.state.update((current) => [toast, ...current]);
  }

  removeToast(id: string): void {
    this.state.update((current) => current.filter((toast) => toast.id !== id));
  }
}
